import { Sidebar } from "@rio-cloud/rio-uikit";
import FormLabel from "@rio-cloud/rio-uikit/FormLabel";
import { type ComponentProps } from "react";
import { ExtractSummary } from "./ExtractSummary";
import { ExtractData } from "./types/types";
import { SummaryData } from "./types/summary";
import { FinancialHealthCard } from "./FinancialHealthCard";
import { ActiveMaintenanceContractCard } from "./ActiveMaintenanceContractCard";
import { PaymentOnDayCard } from "./PaymentOnDayCard";
import { ResponsibleMaintenanceCard } from "./ResponsibleMaintenance";
import { BrandLoyaltyCard } from "./BrandLoyaltyCard";

export type ExtractSidebarProps = ComponentProps<typeof Sidebar> & {
  data: ExtractData;
  assetName: string;
  extractDate: string;
};

export function ExtractSidebar({ data, assetName, extractDate, ...props }: ExtractSidebarProps) {

  const summaryDate: SummaryData = {
    assetName: assetName,
    date: extractDate
  }

  const activeMaintenanceContract = data?.details?.find((item)=>item.description === 'STATUS_CONTRATO')
  const paymentOnDay = data?.details?.find((item)=>item.description === 'ATRASO_PAGAMENTO')
  const responsibleMaintenance = data?.details?.find((item)=>item.description === 'CLV')
  const BrandLoyalty = data?.details?.find((item)=>item.description === 'FIDELIDADE_CONTRATO')

  return (
    <Sidebar
      title={
        <div className="padding-x-10 text-color-dark">
          Extrato para {assetName}
        </div>
      }
      fly
      makeBackdropVisible
      hasBackdrop
      resizable
      minWidth={360}
      maxWidth={1080}
      width={720}
      position={Sidebar.RIGHT}
      {...props}
    >
      <div>
        <div className="cq-container">
          <div className="padding-x-20">
            <ExtractSummary summary={summaryDate} />
          </div>
          <div className="padding-20 display-grid grid-cols-1 cq-700:grid-cols-2 gap-20">
            <div className="cq-700:col-span-full">
              <FinancialHealthCard score={data.score} level={data.level} maxScore={data.maxScore} nextLevelScore={data.nextLevelScore} lastScore={data.lastScore} />
            </div>
            <div>
              <ActiveMaintenanceContractCard score={activeMaintenanceContract?.score} maxScore={activeMaintenanceContract?.maxScore} status={activeMaintenanceContract?.status} contractType={activeMaintenanceContract?.info['contractType']} />
            </div>
            <div>
              <PaymentOnDayCard score={paymentOnDay?.score} maxScore={paymentOnDay?.maxScore} status={paymentOnDay?.status} />
            </div>
            <div>
              <ResponsibleMaintenanceCard score={responsibleMaintenance?.score} maxScore={responsibleMaintenance?.maxScore} status={responsibleMaintenance?.status} />
            </div>
            <div>
              <BrandLoyaltyCard score={BrandLoyalty?.score} maxScore={BrandLoyalty?.maxScore} status={BrandLoyalty?.status} />
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
